// extracted by mini-css-extract-plugin
export default {"options":"styles_options__eKIIZ"};